/**
 * Truncates breadcrumbs dynamically based on visible count
 * Show: [...] [Visible parents] if count exceeds visibleCount
 * 
 * @param {Array} parents - Array of parent objects with id and title
 * @param {Number} visibleCount - Number of parents to show (null = show all)
 * @returns {Array} - Array of breadcrumb items, including ellipsis if needed
 */
export const getTruncatedBreadcrumbs = (parents, visibleCount = null) => {
    if (!parents || parents.length === 0) {
        return [];
    }
    
    // If no limit specified, or parents fit within limit, show all
    if (visibleCount === null || parents.length <= visibleCount) {
        return parents.map((parent, index) => ({ ...parent, isEllipsis: false, originalIndex: index }));
    }
    
    // Show: [...] [Last N visible parents]
    const visibleParents = parents.slice(-visibleCount);
    const truncatedBreadcrumbs = [
        { isEllipsis: true },
        ...visibleParents.map((parent, index) => ({ 
            ...parent, 
            isEllipsis: false, 
            originalIndex: parents.length - visibleCount + index 
        }))
    ];
    
    return truncatedBreadcrumbs;
};
